import React, { useEffect, useState } from 'react'
import {
    IonPage,
    IonContent,
    IonText,
    useIonViewDidEnter,
    IonAlert,
} from '@ionic/react'
import Header from '../../components/Header'
import { AddIcon, DeleteDisableIcon } from '../../conf/images'
//@ts-ignore
import { getAlertList } from '../../service/api/bot'
import ScheduleRemindItem from './Item'
import './index.css'
import { useHistory, useLocation } from 'react-router'
import { useDispatch } from 'react-redux'
import { ScheduleRemindDetailPage, SigninPage } from '../../conf/routePath'
import { setUserInfo } from '../../redux/actions/user'
import wx from 'weixin-js-sdk'
import Message from '../../components/Message'

export type ContactsType = {
    contacts_type: string
    describe: string
    head_url: string
    name: string
    uid: string
}

export type ScheduleRemindList = {
    title: string
    content: Array<string>
    share_alert: boolean
    share_friend_all: boolean
    shard_friends: Array<string>
    share_group_all: boolean
    share_groups: Array<string>
    alert_id: number
    run_datetime: string
    alive: boolean
}

let type = ''

const ScheduleRemind: React.FC<{}> = (props) => {
    const location = useLocation()
    const reduxDispatch = useDispatch()
    // 提取URL的对象 a=11&b=2
    const getSearchString = (key, url) => {
        let searchArr = url.split('&')
        let obj = {}
        for (let i = 0; i < searchArr.length; i++) {
            const tmp_arr = searchArr[i].split('=')
            obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1])
        }
        return obj[key]
    }
    useEffect(() => {
        let { search } = location
        if (search && search.indexOf('?') !== -1) {
            search = search.substr(1)
            const access_token = getSearchString('access_token', search)
            const expires = getSearchString('expires', search)
            type = getSearchString('type', search)
            reduxDispatch(setUserInfo({ access_token, expires }))
        }
        // eslint-disable-next-line
    }, [])

    const history = useHistory()
    const [list, setList] = useState<ScheduleRemindList[]>([])
    const [listMode, setListMode] = useState<boolean>(true)
    const [showAlert, setShowAlert] = useState(false)
    const [addFlag, setAddFlag] = useState(true)

    const removeItem = (id) => {
        setList((item) => item.filter((v) => v.alert_id !== id))
        setListMode(true)
    }
    useIonViewDidEnter(() => {
        getAlertList()
            .then((res) => {
                const { data } = res
                if (data) {
                    setList(data)
                }
            })
            .catch((err) => {
                console.log('err', err)
                const { status, message } = err

                if (type === '1') {
                    setAddFlag(false)
                    if (status && status === 403) {
                        setShowAlert(true)
                    } else {
                        Message.error(message)
                    }
                } else {
                    window.location.replace(SigninPage)
                }
            })
    }, [])

    const isWeiXin = () => {
        const ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i)?.toString() === 'micromessenger') {
            return true
        } else {
            return false
        }
    }

    const sureHandler = () => {
        if (isWeiXin()) {
            wx.closeWindow()
        }
    }
    return (
        <IonPage>
            <IonContent className='mybot-content'>
                <Header title='日程提醒' backable>
                    {!!list?.length && (
                        <img
                            className='newsBotSetDelIcon'
                            src={DeleteDisableIcon}
                            alt='store'
                            onClick={() => setListMode((b) => !b)}
                        />
                    )}
                    {addFlag && (
                        <img
                            className='newsBotSetAddIcon'
                            src={AddIcon}
                            alt='store'
                            onClick={() => {
                                history.push({
                                    pathname: ScheduleRemindDetailPage,
                                    state: { type },
                                })
                            }}
                        />
                    )}
                </Header>
                {Array.isArray(list) && list.length > 0 ? (
                    list.map((item) => (
                        <ScheduleRemindItem
                            mode={listMode}
                            key={item.alert_id}
                            item={item}
                            removeItem={removeItem}
                            type={type}
                        />
                    ))
                ) : (
                    <div className='newsBotNotSetting'>
                        <IonText>
                            {addFlag
                                ? '还没有任何日程提醒设置，点击右上角添加吧!'
                                : '您的登陆已失效，请重新输入“我的日程”进行查看。'}
                        </IonText>
                    </div>
                )}
                <IonAlert
                    isOpen={showAlert}
                    onDidDismiss={() => setShowAlert(false)}
                    header={'提示'}
                    message={'链接已过期，请重新输入“我的日程”进行查看'}
                    buttons={[
                        {
                            text: '取消',
                            role: 'cancel',
                            handler: (blah) => {
                                setShowAlert(false)
                            },
                        },
                        {
                            text: '确认',
                            handler: () => sureHandler(),
                        },
                    ]}
                />
            </IonContent>
        </IonPage>
    )
}

export default ScheduleRemind
